// @flow
/* eslint-disable import/prefer-default-export */
import * as c from './constants';

const namespace = `@${c.MODULE_NAME}`;

// Action types
// ============================================================================

export const UPDATE_ROUTE = `@${namespace}/UPDATE_ROUTE`;

// Core routes
// ============================================================================

export const ROOT = `${namespace}/ROOT`;
export const FORBIDDEN = `${namespace}/FORBIDDEN`;
export const NOT_FOUND = `${namespace}/NOT_FOUND`;

// Public pages
// ============================================================================

export const PAGE_PRIVACY_POLICY = `${namespace}/PAGE_PRIVACY_POLICY`;
export const PAGE_TERMS_AND_CONDITIONS = `${namespace}/PAGE_TERMS_AND_CONDITIONS`;

// Auth pages
// ============================================================================

export const AUTH_ACTIVATE = `${namespace}/AUTH_ACTIVATE`;
export const AUTH_LOGIN = `${namespace}/AUTH_LOGIN`;
export const AUTH_LOGOUT = `${namespace}/AUTH_LOGOUT`;
export const AUTH_REGISTER = `${namespace}/AUTH_REGISTER`;

// CRM pages
// ============================================================================

export const CRM_HOME = `${namespace}/CRM_HOME`;

export const ADVERTISER_LIST = `${namespace}/ADVERTISER_LIST`;
export const ADVERTISER_VIEW = `${namespace}/ADVERTISER_VIEW`;
export const ADVERTISER_VIEW_BALANCE = `${namespace}/ADVERTISER_VIEW_BALANCE`;
export const ADVERTISER_VIEW_BILLING_INFO_EMPTY = `${namespace}/ADVERTISER_VIEW_BILLING_INFO_EMPTY`;
export const ADVERTISER_VIEW_BILLING_INFO = `${namespace}/ADVERTISER_VIEW_BILLING_INFO`;
export const ADVERTISER_VIEW_USER_LIST = `${namespace}/ADVERTISER_VIEW_USER_LIST`;
export const ADVERTISER_VIEW_VOUCHER_LIST = `${namespace}/ADVERTISER_VIEW_VOUCHER_LIST`;

export const AMI_LIST = `${namespace}/AMI_LIST`;

export const DOMAIN_LIST = `${namespace}/DOMAIN_LIST`;
export const DOMAIN_VIEW = `${namespace}/DOMAIN_VIEW`;
export const DOMAIN_VIEW_PRELAND = `${namespace}/DOMAIN_VIEW_PRELAND`;
export const DOMAIN_VIEW_SAFEPAGE = `${namespace}/DOMAIN_VIEW_SAFEPAGE`;
export const DOMAIN_CONFIRM_CHANGES = `${namespace}/DOMAIN_CONFIRM_CHANGES`;

export const MODEM_LIST = `${namespace}/MODEM_LIST`;

export const MY_ACCOUNT = `${namespace}/MY_ACCOUNT`;
export const MY_ACCOUNT_BALANCE = `${namespace}/MY_ACCOUNT_BALANCE`;
export const MY_ACCOUNT_BILLING_INFO_EMPTY = `${namespace}/MY_ACCOUNT_BILLING_INFO_EMPTY`;
export const MY_ACCOUNT_BILLING_INFO = `${namespace}/MY_ACCOUNT_BILLING_INFO`;
export const MY_ACCOUNT_USER_LIST = `${namespace}/MY_ACCOUNT_USER_LIST`;
export const MY_ACCOUNT_VOUCHER_LIST = `${namespace}/MY_ACCOUNT_VOUCHER_LIST`;

export const PAYMENT_LIST = `${namespace}/PAYMENT_LIST`;
export const PRELAND_LIST = `${namespace}/PRELAND_LIST`;
export const PRELAND_VIEW = `${namespace}/PRELAND_VIEW`;
export const PRELAND_VIEW_SOURCE = `${namespace}/PRELAND_VIEW_SOURCE`;

export const PROFILE_LIST = `${namespace}/PROFILE_LIST`;
export const PROFILE_VIEW = `${namespace}/PROFILE_VIEW`;
export const PROFILE_VIEW_FACEBOOK = `${namespace}/PROFILE_VIEW_FACEBOOK`;
export const PROFILE_VIEW_GOOGLE = `${namespace}/PROFILE_VIEW_GOOGLE`;
export const PROFILE_VIEW_PAYPAL = `${namespace}/PROFILE_VIEW_PAYPAL`;
export const PROFILE_VIEW_DOMAIN = `${namespace}/PROFILE_VIEW_DOMAIN`;
export const PROFILE_VIEW_PRELAND = `${namespace}/PROFILE_VIEW_PRELAND`;
export const PROFILE_VIEW_SAFEPAGE = `${namespace}/PROFILE_VIEW_SAFEPAGE`;

export const USER_LIST = `${namespace}/USER_LIST`;

export const VOUCHER_LIST = `${namespace}/VOUCHER_LIST`;

export const STATS = `${namespace}/STATS`;

export const RECORD_LIST = `${namespace}/RECORD_LIST`;

export const AUTOSTART_SESSIONS = `${namespace}/AUTOSTART_SESSIONS`;
export const AUTO_FARMING = `${namespace}/AUTO_FARMING`;

export const REFERRAL_STATS = `${namespace}/REFERRAL_STATS`;



// WEBPACK FOOTER //
// ./src/modules/router/types.js